function handleAddToCart(event, button) {
  event.preventDefault();

  const productCard = button.closest('.product-card-wrapper');
  const selectedVariantId = productCard.querySelector('.selected-variant-id').value;

  button.setAttribute('disabled', true);
  button.innerHTML = '<span>añadiendo...</span>';

  const formData = {
    id: selectedVariantId,
    quantity: 1,
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((item) => {
      updateCartDrawer(true);
    })
    .catch((error) => {
      console.error('Error al añadir al carrito:', error);
    })
    .finally(() => {
      button.removeAttribute('disabled');
      button.innerHTML = '<span>añadir al carrito</span>';
    });
}

document.addEventListener('DOMContentLoaded', function () {
  
  function initializeSizeButtons() {
    const productCards = document.querySelectorAll('.product-card-wrapper:not([data-size-buttons-initialized])');
    productCards.forEach((card) => {
      const showSizeButton = card.querySelector('[data-action="toggle-selector"]');
      const sizeSelector = card.querySelector('[data-selector="size"]');
      const closeIcon = card.querySelector('[data-action="close-selector"]');
      
      if (showSizeButton && sizeSelector && closeIcon) {
        showSizeButton.addEventListener('click', function () {
          sizeSelector.style.display = 'block';
          this.style.visibility = 'hidden';
        });
        
        closeIcon.addEventListener('click', function () {
          sizeSelector.style.display = 'none';
          showSizeButton.style.visibility = 'visible';
        });
        
        card.dataset.sizeButtonsInitialized = 'true';
      }
    });
  }
  
  function initializeDragScroll() {
    const variantButtons = document.querySelectorAll('.variant-buttons:not([data-drag-initialized])');
    variantButtons.forEach((container) => {
      let isDown = false;
      let startX;
      let scrollLeft;

      container.addEventListener('mousedown', (e) => {
        isDown = true;
        container.style.cursor = 'grabbing';
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
        e.preventDefault();
      });

      container.addEventListener('mouseleave', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mouseup', () => {
        isDown = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;
      });

      container.style.cursor = 'grab';
      container.dataset.dragInitialized = 'true';
    });
  }
  
  function initializeAll() {
    initializeSizeButtons();
    initializeDragScroll();
  }
  
  initializeAll();
  
  if (typeof FacetFiltersForm !== 'undefined') {
    const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function(html) {
      originalRenderProductGridContainer.call(this, html);
      setTimeout(() => {
        initializeAll();
      }, 50);
    };
  }
  
  const productGrid = document.querySelector('.product-grid');
  if (productGrid) {
    const observer = new MutationObserver(function(mutations) {
      let shouldReinitialize = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const hasNewProducts = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && 
            (node.classList?.contains('product-card-wrapper') || 
             node.querySelector?.('.product-card-wrapper'))
          );
          
          if (hasNewProducts) {
            shouldReinitialize = true;
          }
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(() => {
          initializeAll();
        }, 100);
      }
    });
    
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
  
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const containerObserver = new MutationObserver(function(mutations) {
      let shouldReinitialize = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          shouldReinitialize = true;
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(() => {
          initializeAll();
        }, 100);
      }
    });
    
    containerObserver.observe(productGridContainer, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
});
